import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ProjectNavbarComponent } from './project-navbar.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ProjectNavbarComponent],
  providers: [],
  exports: [ProjectNavbarComponent]
})

export class ProjectNavbarModule {

}
